import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/icon-social-tg.svg")